import { DirectionalChevron } from "@/components/core/DirectionalChevron";
import { Button } from "@/components/ui/button";
import { Link } from "@/i18n/navigation";

interface SectionTitleProps {
  title: string;
  actionTitle?: string;
  actionLink?: string;
  hasAction?: boolean;
}

export const SectionTitle = ({
  title,
  actionTitle,
  actionLink,
  hasAction = true,
}: SectionTitleProps) => {
  return (
    <div className="mt-2 flex w-full items-center justify-between text-foreground">
      <h3 className="text-lg font-bold md:text-xl lg:text-2xl">{title}</h3>
      {hasAction && actionTitle && actionLink && (
        <div className="flex items-center justify-center">
          <Button
            className="p-0! text-[10px] md:text-xs"
            asChild
            variant={"light"}
          >
            <Link href={actionLink}>{actionTitle}</Link>
          </Button>
          <Button size="icon" variant="light">
            <DirectionalChevron size={12} className="md:size-4" />
          </Button>
        </div>
      )}
    </div>
  );
};
